// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* BORDERS */\n\n/* Icons */\n\n.v-virtual-scroll {\n  display: block;\n  flex: 1 1 auto;\n  height: 100%;\n  max-width: 100%;\n  overflow: auto;\n  position: relative;\n}\n\n.v-virtual-scroll__container {\n  display: block;\n}\n\n.v-virtual-scroll__item {\n  left: 0;\n  position: absolute;\n  right: 0;\n}", ""]);
// Exports
module.exports = exports;
